import { css } from "styled-components";
import { textUppercaseMixin } from "../../shared/mixins/typography";
import { mediaQueries } from "../../shared/mixins/breakpoints";
export const headingTextFontMixin = css `
  text-wrap: balance;
  word-break: break-word;
  font-family: Tungsten-Bold, sans-serif;
  font-weight: 400;
  ${textUppercaseMixin}

  &:lang(ja-jp) {
    font-family: "Noto Sans JP", sans-serif;
    font-weight: 700;
    word-break: normal;
    word-break: auto-phrase;
    text-wrap: unset;
  }
`;
export const bodyTextFontMixin = css `
  text-wrap: balance;
  font-weight: 400;

  @font-face {
    /* Bold body text uses font family DINNEXTW05-Bold. This enables using it under the name DINNextW1G for bolding. */
    font-family: "DINNextW1G";
    src:
      url("https://lolstatic-a.akamaihd.net/webfonts/live/fonts/dinnext/f855f545-9ff1-433c-912f-c58bd2d71d28.woff2")
        format("woff2"),
      url("https://lolstatic-a.akamaihd.net/webfonts/live/fonts/dinnext/8a078fb7-2865-4534-a436-3c2a87c69d57.woff")
        format("woff");
    font-weight: 700;
  }

  @font-face {
    /* Semi-bold body text uses font family DINNextW05-Medium. This enables using it under the name DINNextW1G for semi-bolding. */
    font-family: "DINNextW1G";
    src:
      url("https://lolstatic-a.akamaihd.net/webfonts/live/fonts/dinnext/a077222b-f869-4748-8eda-79372b7c40a1.woff2")
        format("woff2"),
      url("https://lolstatic-a.akamaihd.net/webfonts/live/fonts/dinnext/0297a959-5296-4f45-9729-78daf65d9e43.woff")
        format("woff");
    font-weight: 500;
  }

  @font-face {
    /* Medium body text uses font family DINNextW05-Medium. This enables using it under the name DINNextW1G for medium. */
    font-family: "DINNextW1G";
    src:
      url("https://lolstatic-a.akamaihd.net/webfonts/live/fonts/dinnext/a077222b-f869-4748-8eda-79372b7c40a1.woff2")
        format("woff2"),
      url("https://lolstatic-a.akamaihd.net/webfonts/live/fonts/dinnext/0297a959-5296-4f45-9729-78daf65d9e43.woff")
        format("woff");
    font-weight: 400;
  }

  font-family: "DINNextW1G", sans-serif;

  &:lang(ja-jp) {
    font-family: "Noto Sans JP", sans-serif;
    word-break: normal;
    word-break: auto-phrase;
    text-wrap: unset;
  }
`;
export const body1TypographyMixin = css `
  ${bodyTextFontMixin}
  font-size: 28px;
  line-height: 38px;
  ${mediaQueries.tabletDown} {
    font-size: 22px;
    line-height: 32px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 20px;
    line-height: 28px;
  }
`;
export const body2TypographyMixin = css `
  ${bodyTextFontMixin}
  font-size: 22px;
  line-height: 32px;
  ${mediaQueries.tabletDown} {
    font-size: 18px;
    line-height: 26px;
  }
`;
export const body3TypographyMixin = css `
  ${bodyTextFontMixin}
  font-size: 18px;
  line-height: 28px;
  ${mediaQueries.tabletDown} {
    font-size: 16px;
    line-height: 26px;
  }
`;
export const body4TypographyMixin = css `
  ${bodyTextFontMixin}
  font-size: 16px;
  line-height: 24px;
  ${mediaQueries.tabletDown} {
    font-size: 14px;
    line-height: 22px;
  }
`;
export const body5TypographyMixin = css `
  ${bodyTextFontMixin}
  font-size: 14px;
  line-height: 22px;
  ${mediaQueries.tabletDown} {
    font-size: 12px;
    line-height: 18px;
  }
`;
export const display1TypographyMixin = css `
  ${headingTextFontMixin}
  font-size: 250px;
  line-height: 220px;
  ${mediaQueries.tabletDown} {
    font-size: 115px;
    line-height: 110px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 80px;
    line-height: 80px;
  }
`;
export const display2TypographyMixin = css `
  ${headingTextFontMixin}
  font-size: 150px;
  line-height: 140px;
  ${mediaQueries.tabletDown} {
    font-size: 64px;
    line-height: 65px;
  }
`;
export const display3TypographyMixin = css `
  ${headingTextFontMixin}
  font-size: 100px;
  line-height: 95px;
  ${mediaQueries.tabletDown} {
    font-size: 48px;
    line-height: 48px;
  }

  &:lang(ru-ru),
  &:lang(ja-jp),
  &:lang(ko-kr) {
    font-size: 80px;
    line-height: 80px;
    ${mediaQueries.tabletDown} {
      font-size: 48px;
      line-height: 48px;
    }
  }
`;
export const display4TypographyMixin = css `
  ${headingTextFontMixin}
  font-size: 80px;
  line-height: 80px;
  ${mediaQueries.tabletDown} {
    font-size: 32px;
    line-height: 34px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 28px;
    line-height: 30px;
  }
`;
export const display5TypographyMixin = css `
  ${headingTextFontMixin}
  font-size: 64px;
  line-height: 65px;
  ${mediaQueries.tabletDown} {
    font-size: 28px;
    line-height: 30px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 26px;
    line-height: 28px;
  }
`;
export const display6TypographyMixin = css `
  ${headingTextFontMixin}
  font-size: 48px;
  line-height: 48px;
  ${mediaQueries.tabletDown} {
    font-size: 24px;
    line-height: 25px;
  }
`;
export const display7TypographyMixin = css `
  ${headingTextFontMixin}
  font-size: 32px;
  line-height: 34px;
  ${mediaQueries.tabletDown} {
    font-size: 20px;
    line-height: 20px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 18px;
    line-height: 20px;
  }
`;
export const display8TypographyMixin = css `
  ${headingTextFontMixin}
  font-size: 24px;
  line-height: 25px;
  ${mediaQueries.tabletDown} {
    font-size: 16px;
    line-height: 16px;
  }
`;
export const display9TypographyMixin = css `
  ${headingTextFontMixin}
  font-size: 20px;
  line-height: 20px;
  ${mediaQueries.tabletDown} {
    font-size: 16px;
    line-height: 16px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 14px;
    line-height: 14px;
  }
`;
export const eyebrowTypographyMixin = css `
  ${textUppercaseMixin}
  ${bodyTextFontMixin}
  font-weight: normal;
  font-size: 14px;
  ${mediaQueries.mobileDown} {
    font-size: 12px;
  }
`;
export const tagTypographyMixin = css `
  ${textUppercaseMixin}
  ${bodyTextFontMixin}
  font-weight: 500;
  font-size: 14px;
`;
export const labelTypographyMixin = css `
  ${body4TypographyMixin}
`;
export const textLinkTypographyMixin = css `
  ${bodyTextFontMixin}
  font-weight: 700;
  font-size: 16px;
`;
export const ctaTypographyMixin = css `
  ${headingTextFontMixin}
  ${textUppercaseMixin}
  font-size: 22px;
  text-align: center;
  ${mediaQueries.mobileDown} {
    font-size: 20px;
  }
`;
//# sourceMappingURL=typography.js.map